/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StaffLoginRouteImport } from './routes/staff-login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpRouteImport } from './routes/help'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as LoginMfaRouteImport } from './routes/login.mfa'
import { Route as HelpStaffRouteImport } from './routes/help.staff'
import { Route as HelpDocsRouteImport } from './routes/help.docs'
import { Route as HelpCustomersRouteImport } from './routes/help.customers'
import { Route as AppStaffRouteImport } from './routes/app.staff'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as AppNotificationsRouteImport } from './routes/app.notifications'
import { Route as AppHelpRouteImport } from './routes/app.help'
import { Route as AppCustomerRouteImport } from './routes/app.customer'
import { Route as AppAccountRouteImport } from './routes/app.account'
import { Route as AppStaffIndexRouteImport } from './routes/app.staff.index'
import { Route as AppStaffUsersRouteImport } from './routes/app.staff.users'
import { Route as AppStaffTodayRouteImport } from './routes/app.staff.today'
import { Route as AppStaffSettingsRouteImport } from './routes/app.staff.settings'
import { Route as AppStaffProductsRouteImport } from './routes/app.staff.products'
import { Route as AppStaffJobsTableRouteImport } from './routes/app.staff.jobs-table'
import { Route as AppStaffJobsBoardRouteImport } from './routes/app.staff.jobs-board'
import { Route as AppStaffAnnouncementsRouteImport } from './routes/app.staff.announcements'
import { Route as AppCustomerTeamRouteImport } from './routes/app.customer.team'
import { Route as AppCustomerShopRouteImport } from './routes/app.customer.shop'
import { Route as AppCustomerNewJobRouteImport } from './routes/app.customer.new-job'
import { Route as AppCustomerJobsRouteImport } from './routes/app.customer.jobs'
import { Route as AppCustomerDashboardRouteImport } from './routes/app.customer.dashboard'
import { Route as AppCustomerCheckoutRouteImport } from './routes/app.customer.checkout'
import { Route as AppCustomerCartRouteImport } from './routes/app.customer.cart'
import { Route as AppStaffProductsIndexRouteImport } from './routes/app.staff.products.index'
import { Route as AppCustomerShopIndexRouteImport } from './routes/app.customer.shop.index'
import { Route as AppCustomerJobsIndexRouteImport } from './routes/app.customer.jobs.index'
import { Route as AppStaffProductsProductIdRouteImport } from './routes/app.staff.products.$productId'
import { Route as AppStaffJobsIdRouteImport } from './routes/app.staff.jobs.$id'
import { Route as AppCustomerShopProductIdRouteImport } from './routes/app.customer.shop.$productId'
import { Route as AppCustomerJobsIdRouteImport } from './routes/app.customer.jobs.$id'
import { Route as AppStaffJobsIdTicketRouteImport } from './routes/app.staff.jobs.$id_.ticket'

const StaffLoginRoute = StaffLoginRouteImport.update({
  id: '/staff-login',
  path: '/staff-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const LoginMfaRoute = LoginMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => LoginRoute,
} as any)
const HelpStaffRoute = HelpStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => HelpRoute,
} as any)
const HelpDocsRoute = HelpDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => HelpRoute,
} as any)
const HelpCustomersRoute = HelpCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => HelpRoute,
} as any)
const AppStaffRoute = AppStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerRoute = AppCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIndexRoute = AppStaffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffUsersRoute = AppStaffUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffTodayRoute = AppStaffTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffSettingsRoute = AppStaffSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffProductsRoute = AppStaffProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffJobsTableRoute = AppStaffJobsTableRouteImport.update({
  id: '/jobs-table',
  path: '/jobs-table',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffJobsBoardRoute = AppStaffJobsBoardRouteImport.update({
  id: '/jobs-board',
  path: '/jobs-board',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppStaffAnnouncementsRoute = AppStaffAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppCustomerTeamRoute = AppCustomerTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerShopRoute = AppCustomerShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerNewJobRoute = AppCustomerNewJobRouteImport.update({
  id: '/new-job',
  path: '/new-job',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerJobsRoute = AppCustomerJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerDashboardRoute = AppCustomerDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerCheckoutRoute = AppCustomerCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppCustomerCartRoute = AppCustomerCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => AppCustomerRoute,
} as any)
const AppStaffProductsIndexRoute = AppStaffProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStaffProductsRoute,
} as any)
const AppCustomerShopIndexRoute = AppCustomerShopIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerShopRoute,
} as any)
const AppCustomerJobsIndexRoute = AppCustomerJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerJobsRoute,
} as any)
const AppStaffProductsProductIdRoute =
  AppStaffProductsProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AppStaffProductsRoute,
  } as any)
const AppStaffJobsIdRoute = AppStaffJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => AppStaffRoute,
} as any)
const AppCustomerShopProductIdRoute =
  AppCustomerShopProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AppCustomerShopRoute,
  } as any)
const AppCustomerJobsIdRoute = AppCustomerJobsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppCustomerJobsRoute,
} as any)
const AppStaffJobsIdTicketRoute = AppStaffJobsIdTicketRouteImport.update({
  id: '/jobs/$id_/ticket',
  path: '/jobs/$id/ticket',
  getParentRoute: () => AppStaffRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRouteWithChildren
  '/login': typeof LoginRouteWithChildren
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/staff-login': typeof StaffLoginRoute
  '/app/account': typeof AppAccountRoute
  '/app/customer': typeof AppCustomerRouteWithChildren
  '/app/help': typeof AppHelpRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/staff': typeof AppStaffRouteWithChildren
  '/help/customers': typeof HelpCustomersRoute
  '/help/docs': typeof HelpDocsRoute
  '/help/staff': typeof HelpStaffRoute
  '/login/mfa': typeof LoginMfaRoute
  '/app/': typeof AppIndexRoute
  '/app/customer/cart': typeof AppCustomerCartRoute
  '/app/customer/checkout': typeof AppCustomerCheckoutRoute
  '/app/customer/dashboard': typeof AppCustomerDashboardRoute
  '/app/customer/jobs': typeof AppCustomerJobsRouteWithChildren
  '/app/customer/new-job': typeof AppCustomerNewJobRoute
  '/app/customer/shop': typeof AppCustomerShopRouteWithChildren
  '/app/customer/team': typeof AppCustomerTeamRoute
  '/app/staff/announcements': typeof AppStaffAnnouncementsRoute
  '/app/staff/jobs-board': typeof AppStaffJobsBoardRoute
  '/app/staff/jobs-table': typeof AppStaffJobsTableRoute
  '/app/staff/products': typeof AppStaffProductsRouteWithChildren
  '/app/staff/settings': typeof AppStaffSettingsRoute
  '/app/staff/today': typeof AppStaffTodayRoute
  '/app/staff/users': typeof AppStaffUsersRoute
  '/app/staff/': typeof AppStaffIndexRoute
  '/app/customer/jobs/$id': typeof AppCustomerJobsIdRoute
  '/app/customer/shop/$productId': typeof AppCustomerShopProductIdRoute
  '/app/staff/jobs/$id': typeof AppStaffJobsIdRoute
  '/app/staff/products/$productId': typeof AppStaffProductsProductIdRoute
  '/app/customer/jobs/': typeof AppCustomerJobsIndexRoute
  '/app/customer/shop/': typeof AppCustomerShopIndexRoute
  '/app/staff/products/': typeof AppStaffProductsIndexRoute
  '/app/staff/jobs/$id/ticket': typeof AppStaffJobsIdTicketRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRouteWithChildren
  '/login': typeof LoginRouteWithChildren
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/staff-login': typeof StaffLoginRoute
  '/app/account': typeof AppAccountRoute
  '/app/customer': typeof AppCustomerRouteWithChildren
  '/app/help': typeof AppHelpRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/help/customers': typeof HelpCustomersRoute
  '/help/docs': typeof HelpDocsRoute
  '/help/staff': typeof HelpStaffRoute
  '/login/mfa': typeof LoginMfaRoute
  '/app': typeof AppIndexRoute
  '/app/customer/cart': typeof AppCustomerCartRoute
  '/app/customer/checkout': typeof AppCustomerCheckoutRoute
  '/app/customer/dashboard': typeof AppCustomerDashboardRoute
  '/app/customer/new-job': typeof AppCustomerNewJobRoute
  '/app/customer/team': typeof AppCustomerTeamRoute
  '/app/staff/announcements': typeof AppStaffAnnouncementsRoute
  '/app/staff/jobs-board': typeof AppStaffJobsBoardRoute
  '/app/staff/jobs-table': typeof AppStaffJobsTableRoute
  '/app/staff/settings': typeof AppStaffSettingsRoute
  '/app/staff/today': typeof AppStaffTodayRoute
  '/app/staff/users': typeof AppStaffUsersRoute
  '/app/staff': typeof AppStaffIndexRoute
  '/app/customer/jobs/$id': typeof AppCustomerJobsIdRoute
  '/app/customer/shop/$productId': typeof AppCustomerShopProductIdRoute
  '/app/staff/jobs/$id': typeof AppStaffJobsIdRoute
  '/app/staff/products/$productId': typeof AppStaffProductsProductIdRoute
  '/app/customer/jobs': typeof AppCustomerJobsIndexRoute
  '/app/customer/shop': typeof AppCustomerShopIndexRoute
  '/app/staff/products': typeof AppStaffProductsIndexRoute
  '/app/staff/jobs/$id/ticket': typeof AppStaffJobsIdTicketRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRouteWithChildren
  '/login': typeof LoginRouteWithChildren
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/staff-login': typeof StaffLoginRoute
  '/app/account': typeof AppAccountRoute
  '/app/customer': typeof AppCustomerRouteWithChildren
  '/app/help': typeof AppHelpRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/staff': typeof AppStaffRouteWithChildren
  '/help/customers': typeof HelpCustomersRoute
  '/help/docs': typeof HelpDocsRoute
  '/help/staff': typeof HelpStaffRoute
  '/login/mfa': typeof LoginMfaRoute
  '/app/': typeof AppIndexRoute
  '/app/customer/cart': typeof AppCustomerCartRoute
  '/app/customer/checkout': typeof AppCustomerCheckoutRoute
  '/app/customer/dashboard': typeof AppCustomerDashboardRoute
  '/app/customer/jobs': typeof AppCustomerJobsRouteWithChildren
  '/app/customer/new-job': typeof AppCustomerNewJobRoute
  '/app/customer/shop': typeof AppCustomerShopRouteWithChildren
  '/app/customer/team': typeof AppCustomerTeamRoute
  '/app/staff/announcements': typeof AppStaffAnnouncementsRoute
  '/app/staff/jobs-board': typeof AppStaffJobsBoardRoute
  '/app/staff/jobs-table': typeof AppStaffJobsTableRoute
  '/app/staff/products': typeof AppStaffProductsRouteWithChildren
  '/app/staff/settings': typeof AppStaffSettingsRoute
  '/app/staff/today': typeof AppStaffTodayRoute
  '/app/staff/users': typeof AppStaffUsersRoute
  '/app/staff/': typeof AppStaffIndexRoute
  '/app/customer/jobs/$id': typeof AppCustomerJobsIdRoute
  '/app/customer/shop/$productId': typeof AppCustomerShopProductIdRoute
  '/app/staff/jobs/$id': typeof AppStaffJobsIdRoute
  '/app/staff/products/$productId': typeof AppStaffProductsProductIdRoute
  '/app/customer/jobs/': typeof AppCustomerJobsIndexRoute
  '/app/customer/shop/': typeof AppCustomerShopIndexRoute
  '/app/staff/products/': typeof AppStaffProductsIndexRoute
  '/app/staff/jobs/$id_/ticket': typeof AppStaffJobsIdTicketRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/cookie-policy'
    | '/help'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/staff-login'
    | '/app/account'
    | '/app/customer'
    | '/app/help'
    | '/app/notifications'
    | '/app/settings'
    | '/app/staff'
    | '/help/customers'
    | '/help/docs'
    | '/help/staff'
    | '/login/mfa'
    | '/app/'
    | '/app/customer/cart'
    | '/app/customer/checkout'
    | '/app/customer/dashboard'
    | '/app/customer/jobs'
    | '/app/customer/new-job'
    | '/app/customer/shop'
    | '/app/customer/team'
    | '/app/staff/announcements'
    | '/app/staff/jobs-board'
    | '/app/staff/jobs-table'
    | '/app/staff/products'
    | '/app/staff/settings'
    | '/app/staff/today'
    | '/app/staff/users'
    | '/app/staff/'
    | '/app/customer/jobs/$id'
    | '/app/customer/shop/$productId'
    | '/app/staff/jobs/$id'
    | '/app/staff/products/$productId'
    | '/app/customer/jobs/'
    | '/app/customer/shop/'
    | '/app/staff/products/'
    | '/app/staff/jobs/$id/ticket'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cookie-policy'
    | '/help'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/staff-login'
    | '/app/account'
    | '/app/customer'
    | '/app/help'
    | '/app/notifications'
    | '/app/settings'
    | '/help/customers'
    | '/help/docs'
    | '/help/staff'
    | '/login/mfa'
    | '/app'
    | '/app/customer/cart'
    | '/app/customer/checkout'
    | '/app/customer/dashboard'
    | '/app/customer/new-job'
    | '/app/customer/team'
    | '/app/staff/announcements'
    | '/app/staff/jobs-board'
    | '/app/staff/jobs-table'
    | '/app/staff/settings'
    | '/app/staff/today'
    | '/app/staff/users'
    | '/app/staff'
    | '/app/customer/jobs/$id'
    | '/app/customer/shop/$productId'
    | '/app/staff/jobs/$id'
    | '/app/staff/products/$productId'
    | '/app/customer/jobs'
    | '/app/customer/shop'
    | '/app/staff/products'
    | '/app/staff/jobs/$id/ticket'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/cookie-policy'
    | '/help'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/staff-login'
    | '/app/account'
    | '/app/customer'
    | '/app/help'
    | '/app/notifications'
    | '/app/settings'
    | '/app/staff'
    | '/help/customers'
    | '/help/docs'
    | '/help/staff'
    | '/login/mfa'
    | '/app/'
    | '/app/customer/cart'
    | '/app/customer/checkout'
    | '/app/customer/dashboard'
    | '/app/customer/jobs'
    | '/app/customer/new-job'
    | '/app/customer/shop'
    | '/app/customer/team'
    | '/app/staff/announcements'
    | '/app/staff/jobs-board'
    | '/app/staff/jobs-table'
    | '/app/staff/products'
    | '/app/staff/settings'
    | '/app/staff/today'
    | '/app/staff/users'
    | '/app/staff/'
    | '/app/customer/jobs/$id'
    | '/app/customer/shop/$productId'
    | '/app/staff/jobs/$id'
    | '/app/staff/products/$productId'
    | '/app/customer/jobs/'
    | '/app/customer/shop/'
    | '/app/staff/products/'
    | '/app/staff/jobs/$id_/ticket'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CookiePolicyRoute: typeof CookiePolicyRoute
  HelpRoute: typeof HelpRouteWithChildren
  LoginRoute: typeof LoginRouteWithChildren
  PricingRoute: typeof PricingRoute
  SignupRoute: typeof SignupRoute
  StaffLoginRoute: typeof StaffLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/staff-login': {
      id: '/staff-login'
      path: '/staff-login'
      fullPath: '/staff-login'
      preLoaderRoute: typeof StaffLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/login/mfa': {
      id: '/login/mfa'
      path: '/mfa'
      fullPath: '/login/mfa'
      preLoaderRoute: typeof LoginMfaRouteImport
      parentRoute: typeof LoginRoute
    }
    '/help/staff': {
      id: '/help/staff'
      path: '/staff'
      fullPath: '/help/staff'
      preLoaderRoute: typeof HelpStaffRouteImport
      parentRoute: typeof HelpRoute
    }
    '/help/docs': {
      id: '/help/docs'
      path: '/docs'
      fullPath: '/help/docs'
      preLoaderRoute: typeof HelpDocsRouteImport
      parentRoute: typeof HelpRoute
    }
    '/help/customers': {
      id: '/help/customers'
      path: '/customers'
      fullPath: '/help/customers'
      preLoaderRoute: typeof HelpCustomersRouteImport
      parentRoute: typeof HelpRoute
    }
    '/app/staff': {
      id: '/app/staff'
      path: '/staff'
      fullPath: '/app/staff'
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/help': {
      id: '/app/help'
      path: '/help'
      fullPath: '/app/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/customer': {
      id: '/app/customer'
      path: '/customer'
      fullPath: '/app/customer'
      preLoaderRoute: typeof AppCustomerRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/staff/': {
      id: '/app/staff/'
      path: '/'
      fullPath: '/app/staff/'
      preLoaderRoute: typeof AppStaffIndexRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/users': {
      id: '/app/staff/users'
      path: '/users'
      fullPath: '/app/staff/users'
      preLoaderRoute: typeof AppStaffUsersRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/today': {
      id: '/app/staff/today'
      path: '/today'
      fullPath: '/app/staff/today'
      preLoaderRoute: typeof AppStaffTodayRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/settings': {
      id: '/app/staff/settings'
      path: '/settings'
      fullPath: '/app/staff/settings'
      preLoaderRoute: typeof AppStaffSettingsRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/products': {
      id: '/app/staff/products'
      path: '/products'
      fullPath: '/app/staff/products'
      preLoaderRoute: typeof AppStaffProductsRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/jobs-table': {
      id: '/app/staff/jobs-table'
      path: '/jobs-table'
      fullPath: '/app/staff/jobs-table'
      preLoaderRoute: typeof AppStaffJobsTableRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/jobs-board': {
      id: '/app/staff/jobs-board'
      path: '/jobs-board'
      fullPath: '/app/staff/jobs-board'
      preLoaderRoute: typeof AppStaffJobsBoardRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/staff/announcements': {
      id: '/app/staff/announcements'
      path: '/announcements'
      fullPath: '/app/staff/announcements'
      preLoaderRoute: typeof AppStaffAnnouncementsRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/customer/team': {
      id: '/app/customer/team'
      path: '/team'
      fullPath: '/app/customer/team'
      preLoaderRoute: typeof AppCustomerTeamRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/shop': {
      id: '/app/customer/shop'
      path: '/shop'
      fullPath: '/app/customer/shop'
      preLoaderRoute: typeof AppCustomerShopRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/new-job': {
      id: '/app/customer/new-job'
      path: '/new-job'
      fullPath: '/app/customer/new-job'
      preLoaderRoute: typeof AppCustomerNewJobRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/jobs': {
      id: '/app/customer/jobs'
      path: '/jobs'
      fullPath: '/app/customer/jobs'
      preLoaderRoute: typeof AppCustomerJobsRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/dashboard': {
      id: '/app/customer/dashboard'
      path: '/dashboard'
      fullPath: '/app/customer/dashboard'
      preLoaderRoute: typeof AppCustomerDashboardRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/checkout': {
      id: '/app/customer/checkout'
      path: '/checkout'
      fullPath: '/app/customer/checkout'
      preLoaderRoute: typeof AppCustomerCheckoutRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/customer/cart': {
      id: '/app/customer/cart'
      path: '/cart'
      fullPath: '/app/customer/cart'
      preLoaderRoute: typeof AppCustomerCartRouteImport
      parentRoute: typeof AppCustomerRoute
    }
    '/app/staff/products/': {
      id: '/app/staff/products/'
      path: '/'
      fullPath: '/app/staff/products/'
      preLoaderRoute: typeof AppStaffProductsIndexRouteImport
      parentRoute: typeof AppStaffProductsRoute
    }
    '/app/customer/shop/': {
      id: '/app/customer/shop/'
      path: '/'
      fullPath: '/app/customer/shop/'
      preLoaderRoute: typeof AppCustomerShopIndexRouteImport
      parentRoute: typeof AppCustomerShopRoute
    }
    '/app/customer/jobs/': {
      id: '/app/customer/jobs/'
      path: '/'
      fullPath: '/app/customer/jobs/'
      preLoaderRoute: typeof AppCustomerJobsIndexRouteImport
      parentRoute: typeof AppCustomerJobsRoute
    }
    '/app/staff/products/$productId': {
      id: '/app/staff/products/$productId'
      path: '/$productId'
      fullPath: '/app/staff/products/$productId'
      preLoaderRoute: typeof AppStaffProductsProductIdRouteImport
      parentRoute: typeof AppStaffProductsRoute
    }
    '/app/staff/jobs/$id': {
      id: '/app/staff/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/app/staff/jobs/$id'
      preLoaderRoute: typeof AppStaffJobsIdRouteImport
      parentRoute: typeof AppStaffRoute
    }
    '/app/customer/shop/$productId': {
      id: '/app/customer/shop/$productId'
      path: '/$productId'
      fullPath: '/app/customer/shop/$productId'
      preLoaderRoute: typeof AppCustomerShopProductIdRouteImport
      parentRoute: typeof AppCustomerShopRoute
    }
    '/app/customer/jobs/$id': {
      id: '/app/customer/jobs/$id'
      path: '/$id'
      fullPath: '/app/customer/jobs/$id'
      preLoaderRoute: typeof AppCustomerJobsIdRouteImport
      parentRoute: typeof AppCustomerJobsRoute
    }
    '/app/staff/jobs/$id_/ticket': {
      id: '/app/staff/jobs/$id_/ticket'
      path: '/jobs/$id/ticket'
      fullPath: '/app/staff/jobs/$id/ticket'
      preLoaderRoute: typeof AppStaffJobsIdTicketRouteImport
      parentRoute: typeof AppStaffRoute
    }
  }
}

interface AppCustomerJobsRouteChildren {
  AppCustomerJobsIdRoute: typeof AppCustomerJobsIdRoute
  AppCustomerJobsIndexRoute: typeof AppCustomerJobsIndexRoute
}

const AppCustomerJobsRouteChildren: AppCustomerJobsRouteChildren = {
  AppCustomerJobsIdRoute: AppCustomerJobsIdRoute,
  AppCustomerJobsIndexRoute: AppCustomerJobsIndexRoute,
}

const AppCustomerJobsRouteWithChildren = AppCustomerJobsRoute._addFileChildren(
  AppCustomerJobsRouteChildren,
)

interface AppCustomerShopRouteChildren {
  AppCustomerShopProductIdRoute: typeof AppCustomerShopProductIdRoute
  AppCustomerShopIndexRoute: typeof AppCustomerShopIndexRoute
}

const AppCustomerShopRouteChildren: AppCustomerShopRouteChildren = {
  AppCustomerShopProductIdRoute: AppCustomerShopProductIdRoute,
  AppCustomerShopIndexRoute: AppCustomerShopIndexRoute,
}

const AppCustomerShopRouteWithChildren = AppCustomerShopRoute._addFileChildren(
  AppCustomerShopRouteChildren,
)

interface AppCustomerRouteChildren {
  AppCustomerCartRoute: typeof AppCustomerCartRoute
  AppCustomerCheckoutRoute: typeof AppCustomerCheckoutRoute
  AppCustomerDashboardRoute: typeof AppCustomerDashboardRoute
  AppCustomerJobsRoute: typeof AppCustomerJobsRouteWithChildren
  AppCustomerNewJobRoute: typeof AppCustomerNewJobRoute
  AppCustomerShopRoute: typeof AppCustomerShopRouteWithChildren
  AppCustomerTeamRoute: typeof AppCustomerTeamRoute
}

const AppCustomerRouteChildren: AppCustomerRouteChildren = {
  AppCustomerCartRoute: AppCustomerCartRoute,
  AppCustomerCheckoutRoute: AppCustomerCheckoutRoute,
  AppCustomerDashboardRoute: AppCustomerDashboardRoute,
  AppCustomerJobsRoute: AppCustomerJobsRouteWithChildren,
  AppCustomerNewJobRoute: AppCustomerNewJobRoute,
  AppCustomerShopRoute: AppCustomerShopRouteWithChildren,
  AppCustomerTeamRoute: AppCustomerTeamRoute,
}

const AppCustomerRouteWithChildren = AppCustomerRoute._addFileChildren(
  AppCustomerRouteChildren,
)

interface AppStaffProductsRouteChildren {
  AppStaffProductsProductIdRoute: typeof AppStaffProductsProductIdRoute
  AppStaffProductsIndexRoute: typeof AppStaffProductsIndexRoute
}

const AppStaffProductsRouteChildren: AppStaffProductsRouteChildren = {
  AppStaffProductsProductIdRoute: AppStaffProductsProductIdRoute,
  AppStaffProductsIndexRoute: AppStaffProductsIndexRoute,
}

const AppStaffProductsRouteWithChildren =
  AppStaffProductsRoute._addFileChildren(AppStaffProductsRouteChildren)

interface AppStaffRouteChildren {
  AppStaffAnnouncementsRoute: typeof AppStaffAnnouncementsRoute
  AppStaffJobsBoardRoute: typeof AppStaffJobsBoardRoute
  AppStaffJobsTableRoute: typeof AppStaffJobsTableRoute
  AppStaffProductsRoute: typeof AppStaffProductsRouteWithChildren
  AppStaffSettingsRoute: typeof AppStaffSettingsRoute
  AppStaffTodayRoute: typeof AppStaffTodayRoute
  AppStaffUsersRoute: typeof AppStaffUsersRoute
  AppStaffIndexRoute: typeof AppStaffIndexRoute
  AppStaffJobsIdRoute: typeof AppStaffJobsIdRoute
  AppStaffJobsIdTicketRoute: typeof AppStaffJobsIdTicketRoute
}

const AppStaffRouteChildren: AppStaffRouteChildren = {
  AppStaffAnnouncementsRoute: AppStaffAnnouncementsRoute,
  AppStaffJobsBoardRoute: AppStaffJobsBoardRoute,
  AppStaffJobsTableRoute: AppStaffJobsTableRoute,
  AppStaffProductsRoute: AppStaffProductsRouteWithChildren,
  AppStaffSettingsRoute: AppStaffSettingsRoute,
  AppStaffTodayRoute: AppStaffTodayRoute,
  AppStaffUsersRoute: AppStaffUsersRoute,
  AppStaffIndexRoute: AppStaffIndexRoute,
  AppStaffJobsIdRoute: AppStaffJobsIdRoute,
  AppStaffJobsIdTicketRoute: AppStaffJobsIdTicketRoute,
}

const AppStaffRouteWithChildren = AppStaffRoute._addFileChildren(
  AppStaffRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppCustomerRoute: typeof AppCustomerRouteWithChildren
  AppHelpRoute: typeof AppHelpRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStaffRoute: typeof AppStaffRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppCustomerRoute: AppCustomerRouteWithChildren,
  AppHelpRoute: AppHelpRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStaffRoute: AppStaffRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface HelpRouteChildren {
  HelpCustomersRoute: typeof HelpCustomersRoute
  HelpDocsRoute: typeof HelpDocsRoute
  HelpStaffRoute: typeof HelpStaffRoute
}

const HelpRouteChildren: HelpRouteChildren = {
  HelpCustomersRoute: HelpCustomersRoute,
  HelpDocsRoute: HelpDocsRoute,
  HelpStaffRoute: HelpStaffRoute,
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)

interface LoginRouteChildren {
  LoginMfaRoute: typeof LoginMfaRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginMfaRoute: LoginMfaRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CookiePolicyRoute: CookiePolicyRoute,
  HelpRoute: HelpRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
  PricingRoute: PricingRoute,
  SignupRoute: SignupRoute,
  StaffLoginRoute: StaffLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
